var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41306",
    "data-name": "Group 41306",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150.225,
    viewBox: "0 0 150 150.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19771",
    "data-name": "Path 19771",
    d: "M248.156,225.779a75.1,75.1,0,1,1-4.805,150.072,72.167,72.167,0,0,1-30.435-8.624,5.64,5.64,0,0,0-4.93-.408c-8.6,2.858-17.244,5.582-25.854,8.4-2.649.871-5.159,1.21-7.375-.931-2.315-2.241-2-4.83-1.1-7.589,2.863-8.7,5.727-17.407,8.4-26.166a6.267,6.267,0,0,0-.408-4.3A75.048,75.048,0,0,1,237.086,226.75C240.736,226.187,244.466,226.093,248.156,225.779ZM187.883,361c6.588-2.126,12.643-3.883,18.544-6.05A11.152,11.152,0,0,1,216.9,356a57.985,57.985,0,0,0,27.492,8.136,63.21,63.21,0,0,0,66.293-70.577c-4.183-37.878-42.062-63.676-78.921-53.747A63.188,63.188,0,0,0,193.306,332.8a9.431,9.431,0,0,1,.926,8.574C192,347.6,190.134,353.962,187.883,361Z",
    transform: "translate(-172.861 -225.779)",
    fill: "#fffbf5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19772",
    "data-name": "Path 19772",
    d: "M187.922,253.942a7.26,7.26,0,1,1,7.185-7.259A7.186,7.186,0,0,1,187.922,253.942Z",
    transform: "translate(-142.102 -171.489)",
    fill: "#fffbf5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19773",
    "data-name": "Path 19773",
    d: "M201,246.728a7.261,7.261,0,1,1-7.141-7.3A7.179,7.179,0,0,1,201,246.728Z",
    transform: "translate(-118.691 -171.49)",
    fill: "#fffbf5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19774",
    "data-name": "Path 19774",
    d: "M206.875,246.728a7.259,7.259,0,1,1-7.141-7.3A7.172,7.172,0,0,1,206.875,246.728Z",
    transform: "translate(-95.275 -171.49)",
    fill: "#fffbf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.e1b879d433904c17e2d6a7af544ee970.svg";
export { ForwardRef as ReactComponent };